<template>
  <div v-if="hasMessage" class="general-announcement">
    <Announcement
      :id="`announcement-${id}`"
      :title="title"
      :message="message"
      :additional-info="additionalInfo"
      :additional-info-schedule="additionalInfoSchedule"
      :collapsed="collapsed"
      @toggle="handleToggle"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import Announcement from './index.vue';
import { getMaintenanceInfo, getVisibleAnnouncements } from '@/services/announcement.service';

const props = defineProps({
  title: {
    type: String,
    default: 'お知らせ',
  },
  message: {
    type: String,
    default: '',
  },
  additionalInfo: {
    type: String,
    default: '',
  },
  additionalInfoSchedule: {
    type: String,
    default: '',
  },
  isCollapsed: {
    type: Boolean,
    default: false,
  },
  id: {
    type: [String, Number],
    required: true,
  },
});

// ローカルの状態を管理
const collapsed = ref(props.isCollapsed);
const hasMessage = ref(!!props.message);
const maintenanceInfo = ref<any>(null);
const announcements = ref<any[]>([]);

// propsの変更を監視
watch(
  () => props.isCollapsed,
  (newVal) => {
    collapsed.value = newVal;
  }
);

// トグルイベントハンドラ - indexコンポーネントからの状態変更を受け取る
const handleToggle = ({ isCollapsed }: { isCollapsed: boolean }) => {
  collapsed.value = isCollapsed;
};

// コンポーネントのマウント時
onMounted(async () => {
  // クッキーの状態はindexコンポーネントで管理されるようになったので
  // ここではpropsの値を使用する
  collapsed.value = props.isCollapsed;

  // お知らせの数を取得するための初期化
  maintenanceInfo.value = await getMaintenanceInfo();
  announcements.value = await getVisibleAnnouncements();
});
</script>

<style scoped>
.general-announcement {
  padding: 16px auto;
  white-space: pre-line;
}
</style>
